/* globals _refersion, _rfsn */
'use strict';

import $ from 'jquery';
import StripeForm from '@/js/modules/stripe_form';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  if ($('body').is('#plans-purchase-plan')) {
    function verifyPromo(promoCode, plan, submittingForm) {
      return new Promise((resolve, _) => {
        if (!promoCode.length) {
          resolve(true);
          return;
        }

        const xhr = $.post('/plans/xhr_verify_promo', { promo_code: promoCode, plan });
        xhr.then((data) => {
          console.log(data);

          if (data === null) {
            // if promo is invalid just clear it upon form submission instead of showing the error
            if (submittingForm) {
              $('#promo').val('');
            } else {
              $('label.form-error[for=promo]').css('display', 'block').fadeOut(1500);
              $('#promo').addClass('field--stripe-form-promo-error').focus();
            }

            resolve(true);
          } else {
            $('#promo').removeClass('field--stripe-form-promo-error');
            $('.stripe-form__promo-container').hide();
            $('.stripe-form__show-promo-field').hide();

            $('.purchase-plan__discount-price').html(data.price);
            $('.purchase-plan__discount-months').html(data.months);
            $('.purchase-plan__footnote-months').html(data.months);

            $('.purchase-plan__total').hide();
            $('.purchase-plan__discount').show();
            $('.purchase-plan__footnote').show();

            resolve(true);
          }
        });
      });
    }

    $(document).on('click', '.stripe-form__show-promo-field', (e) => {
      $(e.target).hide();
      $('.stripe-form__promo-container').css('display', 'flex').find('input[type=text]').focus();

      return false;
    });

    $(document).on('click', '.stripe-form__apply-promo', (e) => {
      const $form = $(e.target).closest('form');
      const promo = $form.find('#promo').val();
      const plan = $form.data().plan;

      verifyPromo(promo, plan, false);

      return false;
    });

    // automatically apply plan if ?promo param is present
    if ($('.purchase-plan__form').length && $('.field--stripe-form-promo').val()) {
      $('.stripe-form__apply-promo').click();
    }

    const stripeForm = new StripeForm();
    $(document).on('click', '.p-button--purchase-plan', (e) => {
      const $form = $('.purchase-plan__form');
      const url = $form.prop('action');
      const plan = $form.data().plan;
      const promo = $form.find('#promo').val();
      const yearly = $form.find('#yearly').val();
      const fromPlan = $form.data().fromPlan;
      const toPlan = $form.data().toPlan;
      const price = $form.data().price;

      verifyPromo(promo, plan, true).then((promoValid) => {
        if (promoValid) {
          const $button = $('.p-button--purchase-plan');
          $button.addClass('button-loading');
          stripeForm.submit().then((result) => {
            $button.removeClass('button-loading');
            if (!$('.form-error--stripe:visible').length) {
              $button.addClass('button-loading');
              if (result.token) {
                const token = result.token.id;
                $.post(url, { stripe_token: token, promo, yearly }, function (data) {
                  if (data.error) {
                    alert(`An error occured: ${data.error}`);
                    $button.removeClass('button-loading').prop('disabled', false);
                  } else {
                    console.log('Plan created');
                    if (typeof _refersion !== 'undefined') {
                      console.log('Refersion loaded');
                      _refersion(function () {
                        _rfsn._setSource('STRIPE');
                        _rfsn._addCart(data.stripe_customer_id);
                        console.log(`Called refersion with ${data.stripe_customer_id} param`);
                        window.location.assign(
                          `/projects?upgraded=true&from_plan=${fromPlan}&to_plan=${toPlan}&value=${price}`
                        );
                      });
                    } else {
                      window.location.assign(
                        `/projects?upgraded=true&from_plan=${fromPlan}&to_plan=${toPlan}&value=${price}`
                      );
                    }
                  }
                });
              } else {
                $button.removeClass('button-loading');
                alert('Credit card transaction failed.');
              }
            }
          });
        }
      });

      return false;
    });
  }
});
